import script from "./OtherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherForm.vue?vue&type=script&setup=true&lang=js"

import "./OtherForm.vue?vue&type=style&index=0&id=a56a6782&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a56a6782"]])

export default __exports__